// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2fESP","errorLogs":"EditorFooter_errorLogs__VYcX_"};